<h2 mat-dialog-title>
	<mat-icon class="text-gfx-primary">error</mat-icon>
	{{ title }}
</h2>
<mat-dialog-content>{{ message }} </mat-dialog-content>
<mat-dialog-actions>
	<button mat-flat-button class="gfx-button-primary" type="button" (click)="dialogRef.close()">{{ okText }}</button>
</mat-dialog-actions>
